import {apiFetch} from 'src/api/fetch'

import type {AssignDocumentRequest, JobDocument} from './schemas'
import {AssignDocumentRequestSchema, JobDocumentSchema} from './schemas'

export async function listJobDocuments(jobId: string): Promise<JobDocument[]> {
    const raw = await apiFetch<unknown>(`/jobs/${jobId}/documents`)
    return JobDocumentSchema.array().parse(raw)
}

export async function assignDocumentToJob(
    jobId: string,
    input: AssignDocumentRequest,
): Promise<JobDocument> {
    const body = AssignDocumentRequestSchema.parse(input)
    const raw = await apiFetch<unknown>(`/jobs/${jobId}/documents`, {
        method: 'POST',
        body: JSON.stringify(body),
    })
    return JobDocumentSchema.parse(raw)
}

export async function unassignDocumentFromJob(jobId: string, documentId: string): Promise<void> {
    await apiFetch<void>(`/jobs/${jobId}/documents/${documentId}`, {
        method: 'DELETE',
    })
}

export function getJobDocumentDownloadUrl(jobId: string, documentId: string): string {
    return `/api/jobs/${jobId}/documents/${documentId}/content`
}
